export default {
  filterModes: {
    label: 'Mode',
    options: {
      // like: 'Like',
      // equals: 'Equals',
      // list: 'List',
      eq: 'Equals',
    },
  },
  noItemsSelected: 'Keine Zeile(n) ausgewählt',
  confirm: 'Bist du sicher?',
  fields: {
    action: 'Aktion',
    status: 'Status',
  },
  status: {
    title: 'Status',
    active: 'Aktiv',
    inactive: 'Inaktiv',
  },
  searchByColumns: 'Suche nach Feld',
  search: 'Suche',
  noMatchingResults: 'Keine passenden Einträge gefunden',
  noDataAvailable: 'Keine Daten vorhanden',
  rowsPerPageText: 'Zeilen pro Seite:',
  records: 'Zeilen',
  page: 'Seite',
  from: 'von',
  add: 'Hinzufügen',
  all: 'Alle',
  buttons: {
    edit: 'Bearbeiten',
    save: 'Speichern',
    suspend: 'Verwerfen',
    restore: 'Wiederherstellen',
    delete: 'Löschen',
    editSelected: 'Selektion bearbeiten',
    suspendSelected: 'Selektion verwerfen',
    restoreSelected: 'Selektion wiederherstellen',
    deleteSelected: 'Selektion löschen',
    download: 'Herunterladen',
    show: 'Anzeigen',
    refreshTable: 'Tabelle aktualisieren',
    copyToExcel: 'Nach Excel kopieren',
    clearFilters: 'Filter löschen',
  },
}
